import React from 'react';

import { getReservationStatusInfo } from '../../../shared/helpers';
import { RESERVATION_STATUS } from '../../../shared/types';

export function ReservationStatusHeader({ status }: { status: RESERVATION_STATUS }) {
  const statusInfo = getReservationStatusInfo(status);

  return (
    <div
      className="flex items-center mb-6 gap-2 md:flex-row flex-col"
      data-testid="reservation-status-header"
    >
      {statusInfo.icon}
      <div className="md:text-start text-center">
        <p className="font-semibold leading-6">{statusInfo.title}</p>
        {statusInfo.subtitle && (
          <p className="text-[13px] leading-6 text-neutral-soft">{statusInfo.subtitle}</p>
        )}
      </div>
    </div>
  );
}
